import { http } from '@/lib/http'
import urlJoin from 'url-join'

export default class Repository {
  constructor(public path: string) {}

  async _get(query?: string, subPath?: string) {
    const path = this.genPath(query, subPath)
    const response = await http.get(path)

    return response.data
  }

  async _post<T>(params?: T, subPath?: string) {
    const path = this.genPath(undefined, subPath)
    const response = await http.post(path, params)

    return response.data
  }

  genPath(query?: string, subPath?: string) {
    let path = this.path

    if (subPath) {
      path = urlJoin(path, subPath)
    }

    return query ? urlJoin(path, `?query=${query}`) : path
  }
}
